import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import moment from 'moment';
// utils
import { initialsUpperCase } from 'utils/textFormat';
import { handlerErrors } from 'utils/handleErrors';
import formatMoney from 'utils/formatMoney';

// components
import LoadingCar from '../../../components/loading/LoadingCar';

// api
import { getPluginOrderDetail } from '../../../api/Api-user';

const PluginOrderDetail = () => {
  const title = 'Detalle pedido';
  const description = 'Detalle Pedido Plataforma Autopaquete';
  const history = useHistory();
  // Local State
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [shippings, setShippings] = useState(false);

  const getStatusColor = (status) => {
    const color = {
      Pendiente: 'secondary',
      Completada: 'success',
      Incompleta: 'warning',
      Cancelada: 'alternate',
    };
    return color[status] || 'alternate';
  };
  useEffect(() => {
    const handlerGetOrderDetail = async () => {
      try {
        const response = await getPluginOrderDetail(orderId);
        // console.log('=== get order detail response=== :', response);
        if (response.order_items !== undefined) {
          setOrder(response);
        }
      } catch (error) {
        handlerErrors(error);
        history.goBack();
      } finally {
        setIsLoading(false);
      }
    };
    handlerGetOrderDetail();
  }, []);

  return (
    <>
      {isLoading && <LoadingCar />}
      <div id="pageContainer">
        <HtmlHead title={title} description={description} />
        <div className="page-title-container">
          <Row className="g-0">
            {/* Title Start */}
            <Col className="col-auto mb-3 mb-sm-0 me-auto">
              <div className="muted-link pb-1 d-inline-block hidden breadcrumb-back cursor-pointer" onClick={() => history.goBack()}>
                <CsLineIcons icon="chevron-left" size="13" />
                <span className="align-middle text-small ms-1">Atrás</span>
              </div>
              <h1 className="mb-0 pb-0 display-4" id="title">
                {title}
              </h1>
            </Col>
            {/* Title End */}
          </Row>
        </div>

        <Row>
          <Col xl="8" xxl="9">
            {/* Store and order Start */}
            <h2 className="small-title invisible">Tienda</h2>
            <Row className="g-2 mb-5">
              <Col sm="6">
                <Card className="sh-13 sh-lg-15 sh-xl-14">
                  <Card.Body className="h-100 py-3 d-flex align-items-center">
                    <Row className="g-0 align-items-center">
                      <Col xs="auto" className="pe-3">
                        <div className="border border-primary sw-6 sh-6 rounded-xl d-flex justify-content-center align-items-center">
                          <CsLineIcons icon="shop" className="text-primary" />
                        </div>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center lh-1-25">Tienda</div>
                        <div className="text-primary">{order?.store_ecommerce_name}</div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm="6">
                <Card className="sh-13 sh-lg-15 sh-xl-14">
                  <Card.Body className="h-100 py-3 d-flex align-items-center">
                    <Row className="g-0 align-items-center">
                      <Col xs="auto" className="pe-3">
                        <div className="border border-primary sw-6 sh-6 rounded-xl d-flex justify-content-center align-items-center">
                          <CsLineIcons icon="calendar" className="text-primary" />
                        </div>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center lh-1-25">Fecha</div>
                        <div className="text-primary">{moment(order?.created_date).format('DD-MM-YYYY HH:mm')}</div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm="6">
                <Card className="sh-13 sh-lg-15 sh-xl-14">
                  <Card.Body className="h-100 py-3 d-flex align-items-center">
                    <Row className="g-0 align-items-center">
                      <Col xs="auto" className="pe-3">
                        <div className="border border-primary sw-6 sh-6 rounded-xl d-flex justify-content-center align-items-center">
                          <CsLineIcons icon="note" className="text-primary" />
                        </div>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center lh-1-25">ID</div>
                        <div className="text-primary">{order?.order_key}</div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm="6">
                <Card className="sh-13 sh-lg-15 sh-xl-14">
                  <Card.Body className="h-100 py-3 d-flex align-items-center">
                    <Row className="g-0 align-items-center">
                      <Col xs="auto" className="pe-3">
                        <div className="border border-primary sw-6 sh-6 rounded-xl d-flex justify-content-center align-items-center">
                          <CsLineIcons icon="cart" className="text-primary" />
                        </div>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center lh-1-25">Compra</div>

                        <div className="text-primary">
                          {' '}
                          <span className="text-small text-muted">$</span>
                          {formatMoney(order?.total_order)}
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {/* Store and order End */}
            <Row>
              <div className="text-end">
                <Badge bg={getStatusColor(order?.readable_status)} className="text-uppercase fw-bolder" style={{ fontSize: '12px' }}>
                  {order?.readable_status}
                </Badge>
              </div>
            </Row>

            {/* Product List Start */}
            <h2 className="small-title">Productos</h2>
            <Card className="mb-5" style={{ minWidth: '300px' }}>
              <Card.Body className="ps-3 ps-sm-5">
                <Row className="g-0 h-100 px-4 mb-2 align-content-center d-none d-lg-flex align-items-center custom-sort">
                  <Col md="6" className="d-flex flex-column mb-lg-0 pe-3">
                    <div className="text-muted text-small cursor-pointer">NOMBRE</div>
                  </Col>
                  <Col md="2" className="d-flex flex-column pe-1 justify-content-center align-items-end align-items-lg-center bg-infox">
                    <div className="text-muted text-small cursor-pointeR">ID</div>
                  </Col>
                  <Col md="1" className="d-flex flex-column pe-1 justify-content-center align-items-center align-items-lg-end bg-warningx">
                    <div className="text-muted text-small cursor-pointeR">CANTIDAD</div>
                  </Col>
                  <Col md="2" className="d-flex flex-column ps-4 ps-lg-0 pe-1 justify-content-center align-items-center bg-successx">
                    <div className="text-muted text-small cursor-pointeR">ENVIADOS</div>
                  </Col>
                  <Col md="1" className="d-flex flex-column pe-1 justify-content-center align-items-start">
                    <div className="text-muted text-small cursor-pointer">TOTAL</div>
                  </Col>
                  {/* <Col md="3" className="d-flex flex-column pe-1 justify-content-center align-items-end">
                    <div className="text-muted text-small cursor-pointer">CIUDAD</div>
                  </Col> */}
                </Row>
                {order?.order_items?.length > 0 &&
                  order?.order_items.map((item, index) => (
                    <Card className="mb-3 px-0" key={index}>
                      <Row className="g-0 h-100 sh-lg-10 position-relative overflow-y-hidden">
                        <Col className="py-4 py-lg-0 px-4 h-100 card bg-light" style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5)' }}>
                          <Row className="g-0 h-100 align-content-center">
                            <Col xs="10" lg="6" className="mb-4 mb-lg-0 pe-lg-3 h-lg-100 d-flex flex-column justify-content-center order-1 bg-infoW">
                              <div className="text-muted text-small d-lg-none">Nombre</div>
                              <div className="lh-2 text-primary">{item?.name}</div>
                            </Col>
                            <Col
                              xs="2"
                              lg="2"
                              className="pe-1 mb-4 mb-lg-0 d-flex flex-column justify-content-center align-items-end align-items-lg-center order-4 order-lg-2 bg-infox"
                            >
                              <div className="text-muted text-small d-lg-none">ID</div>
                              <div className="lh-1 text-alternate ">{item?.id}</div>
                            </Col>
                            <Col
                              xs="4"
                              lg="1"
                              className="pe-1 mb-4 mb-lg-0 d-flex flex-column justify-content-center align-items-lg-end order-4 order-lg-2 bg-warningx"
                            >
                              <div className="text-muted text-small d-lg-none">Cantidad</div>
                              <div className="lh-1 text-alternate ">{item?.quantity}</div>
                            </Col>
                            <Col
                              xs="4"
                              lg="2"
                              className="mb-4 mb-lg-0 ps-lg-0 d-flex flex-column justify-content-lg-center align-items-end align-items-lg-center order-5 order-lg-3 bg-successx"
                            >
                              <div className="text-muted text-small d-lg-none">Enviados</div>
                              <div className="lh-1 text-alternate">{Number(item?.quantity || 0) - Number(item?.items_to_dispatch || 0)}</div>
                            </Col>
                            <Col
                              xs="4"
                              lg="1"
                              className="d-flex flex-column mb-4 mb-lg-0 pe-1 justify-content-center align-items-end align-items-lg-center order-last bg-secondaryw"
                            >
                              <div className="text-muted text-small d-lg-none">Total</div>

                              <div className="text-primary">
                                {' '}
                                <span className="text-small text-muted">$</span>
                                {formatMoney(item?.total)}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  ))}
              </Card.Body>
            </Card>
            {/* Product List End */}
            {/* shippings Start */}
            {shippings && (
              <>
                <h2 className="small-title">Guías</h2>
                <Card className="mb-5" style={{ minWidth: '300px' }}>
                  <Card.Body className="ps-3 ps-sm-5">
                    {/* {order?.order_items?.length > 0 && order?.order_items.map((item) => <div key={item.id}>{item.name}</div>)} */}
                  </Card.Body>
                </Card>
              </>
            )}
            {/* shippings End */}
          </Col>
          {/* Shipping data Start */}
          <Col xl="4" xxl="3">
            <h2 className="small-title">Datos de envío</h2>
            <Card className="mb-5">
              <Card.Body>
                <div className="mb-5">
                  <p className="text-small text-muted mb-2">CLIENTE</p>
                  <Row className="g-0 mb-0">
                    <Col className="text-primary">{initialsUpperCase(order?.customer_name || order?.full_name)}</Col>
                  </Row>
                  <Row className="g-0 mb-2">
                    <Col>
                      <div className="text-alternate">{`ID: ${initialsUpperCase(order?.customer_id)}`}</div>
                    </Col>
                  </Row>

                  <p className="text-small text-muted mb-2 mt-5">DIRECCIÓN 1 </p>
                  <Row className="g-0 mb-2">
                    <Col className="text-alternate">{initialsUpperCase(order?.address_1 || 'no disponible')}</Col>
                  </Row>
                  <p className="text-small text-muted mb-2 mt-5">DIRECCIÓN 2 </p>
                  <Row className="g-0 mb-2">
                    <Col className="text-alternate">{initialsUpperCase(order?.address_2 || 'no disponible')}</Col>
                  </Row>
                  <p className="text-small text-muted mb-2 mt-5">CÓDIGO POSTAL</p>
                  <Row className="g-0 mb-2">
                    <div className="text-alternate">{order?.zip_code || 'No Disponible'}</div>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
          {/* Shipping data End */}
        </Row>
      </div>
    </>
  );
};
export default PluginOrderDetail;
